var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('region-featured-products-section',{staticClass:"region-featured-products-section",attrs:{"title":_vm.attributes.regionFeaturedProducts_title,"products":_vm.mappedProducts}})}
var staticRenderFns = []

export { render, staticRenderFns }